import { render, staticRenderFns } from "./UpscaleProgress.vue?vue&type=template&id=5c80feaa&scoped=true"
import script from "./UpscaleProgress.vue?vue&type=script&lang=js"
export * from "./UpscaleProgress.vue?vue&type=script&lang=js"
import style0 from "./UpscaleProgress.vue?vue&type=style&index=0&id=5c80feaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c80feaa",
  null
  
)

export default component.exports